import React, { useState } from 'react';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';

interface AdminLayoutProps {
    children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
    const [sidebarVisible, setSidebarVisible] = useState(true);

    const toggleSidebar = () => {
        setSidebarVisible(!sidebarVisible);
    };

    return (
        <div className="admin-layout flex h-screen">
            {/* Sidebar */}
            <div className={`admin-sidebar ${sidebarVisible ? 'sidebar-visible' : 'sidebar-hidden'}`}>
                <AdminSidebar
                    visible={sidebarVisible}
                    onToggle={toggleSidebar}
                />
            </div>


            {/* Main Content Area */}
            <div className={`admin-main flex-1 flex flex-col ${sidebarVisible ? 'main-with-sidebar' : 'main-full'}`}>
                {/* Header */}
                <div className="admin-header sticky top-0 z-4">
                    <AdminHeader
                        onToggleSidebar={toggleSidebar}
                        sidebarVisible={sidebarVisible}
                    />
                </div>

                {/* Content */}
                <div className="admin-content  flex-col overflow-hidden p-4">
                    {children}
                </div>
            </div>

            {/* Mobile Overlay */}
            {sidebarVisible && (
                <div
                    className="sidebar-overlay fixed top-0 left-0 w-full h-full bg-black-alpha-50 z-3 md:hidden"
                    onClick={() => setSidebarVisible(false)}
                />
            )}

            <style>{`
                .admin-layout {
                    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
                    height: 100vh;
                 
                    overflow: hidden;
                }

                .admin-sidebar {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 280px;
                    height: 100vh;
                    background: #ffffff;
                    border-right: 1px solid #e5e7eb;
                    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
                    transition: transform 0.3s ease;
                    z-index: 1000;
                    overflow-y: auto;
                }

                .sidebar-visible {
                    transform: translateX(0);
                }

                .sidebar-hidden {
                    transform: translateX(-100%);
                }

                .admin-main {
                    transition: margin-left 0.3s ease;
                    height: 100vh;
                    background: #f8fafc;
                    display: flex;
                    flex-direction: column;
                }

                .main-with-sidebar {
                    margin-left: 280px;
                }

                .main-full {
                    margin-left: 0;
                }

                .admin-header {
                    background: #ffffff;
                    border-bottom: 1px solid #e5e7eb;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                    flex-shrink: 0;
                }

                .admin-content {
                    background: #f8fafc;
                    flex: 1;
                    overflow: hidden;
                }

                /* Mobile Responsive */
                @media (max-width: 768px) {
                    .admin-sidebar {
                        width: 280px;
                        transform: translateX(-100%);
                    }

                    .sidebar-visible {
                        transform: translateX(0);
                    }

                    .admin-main {
                        margin-left: 0 !important;
                    }

                    .main-with-sidebar {
                        margin-left: 0;
                    }
                }

                /* Scrollbar Styling */
                .admin-sidebar::-webkit-scrollbar {
                    width: 6px;
                }

                .admin-sidebar::-webkit-scrollbar-track {
                    background: #f1f5f9;
                }

                .admin-sidebar::-webkit-scrollbar-thumb {
                    background: #cbd5e1;
                    border-radius: 3px;
                }

                .admin-sidebar::-webkit-scrollbar-thumb:hover {
                    background: #94a3b8;
                }
            `}</style>
        </div>
    );
};

export default AdminLayout;
